// Links for the public website (SiteLayout / SiteHome).
//
// Every page is part of this app, at a relative path, so links work on
// whichever host serves the site. The content pages keep their old Wix
// addresses. On the website's own host (www.nhca.co.uk) the home page is "/";
// elsewhere (query.nhca.co.uk, dev) "/" is the results app and the website's
// home page is at /newsite. WWW is for the NHCA bar's "Home", which must
// reach the website's home page from any host.

const WWW = 'https://www.nhca.co.uk';
const QUERY = 'https://query.nhca.co.uk';

// www.nhca.co.uk, or any www.* name (a hosts-file test of the cutover).
export function isWebsiteHost(hostname = window.location.hostname) {
  return hostname === 'nhca.co.uk' || hostname.startsWith('www.');
}

// The real site's addresses. Anything else (localhost, the LAN, a dev tunnel
// such as dev.nhca.co.uk) is a copy whose links should stay on that copy.
const PRODUCTION_HOSTS = ['nhca.co.uk', 'www.nhca.co.uk', 'query.nhca.co.uk', 'live.nhca.co.uk'];

export function isProductionHost(hostname = window.location.hostname) {
  return PRODUCTION_HOSTS.includes(hostname);
}

// The logins (secretaries, Calendar Editor, Results Admin, Web Admin) all live
// on query.nhca.co.uk: their emailed links go there (APP_BASE_URL), and a
// browser keeps logins per address. On www they send you over to query.
export const PORTAL_PATHS = ['/secretary', '/calendar-editor', '/results-admin', '/site-admin'];

export function portalUrl(path) {
  return isWebsiteHost() ? QUERY + path : path;
}

export const links = {
  // On the website "/"; on query.nhca.co.uk (and live ...) the website itself;
  // in dev, the preview at /newsite.
  home: isWebsiteHost() ? '/' : (isProductionHost() ? `${WWW}/` : '/newsite'),
  www: `${WWW}/`,
  introduction: '/introduction',
  faq: '/faq',
  classes: '/classes',
  giveItAGo: '/give-it-a-go',
  rules: '/rules',
  membership: '/membership',
  targetTimes: '/target-times',
  hills: '/hills',
  photos: '/photos',
  videos: '/videos',
  archives: '/archives',
  contact: '/contact',
  privacy: '/privacy-statement',
  results: '/results-hub',
  calendar: '/calendar',
  championship: '/championship',
  records: '/records',
  liveTiming: 'https://live.nhca.co.uk',
  facebook: 'https://www.facebook.com/groups/105493316194882',
  youtube: 'https://www.youtube.com/channel/UC8MAzXiRvzaDLOlrgWYQv8g',
};

export const introductionMenu = [
  { label: 'Introduction', href: links.introduction },
  { label: 'FAQ', href: links.faq },
  { label: 'Classes', href: links.classes },
  { label: 'Give it a go', href: links.giveItAGo },
  { label: 'Rules', href: links.rules },
  { label: 'Membership', href: links.membership },
  { label: 'Hills', href: links.hills },
];

export const secLoginMenu = [
  { label: 'Event Secretary', href: portalUrl('/secretary') },
  { label: 'FE Secretary', href: portalUrl('/secretary?subclass=FE') },
  { label: 'RL Secretary', href: portalUrl('/secretary?subclass=RL') },
  { label: 'VC Secretary', href: portalUrl('/secretary?subclass=VC') },
  { label: 'Membership Secretary', href: portalUrl('/secretary?subclass=MEMBERSHIP') },
  { label: 'Financial Secretary', href: portalUrl('/secretary?subclass=FINANCIAL') },
  { label: 'Calendar Editor', href: portalUrl('/calendar-editor') },
  { label: 'Results Admin', href: portalUrl('/results-admin') },
  { label: 'Web Admin', href: portalUrl('/site-admin') },
];

// The home page's photos when no uploaded image is chosen in Web Admin.
export const HOME_PHOTOS = {
  hero: '/site/hero.jpg',
  intro: '/site/give-it-a-go.jpg',
};

// Today's date in the UK, YYYY-MM-DD (the notice bar's "show until").
export function todayInLondon() {
  return new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/London' }).format(new Date());
}
